/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type { UserBusinessesResponse, UserProfileResponse } from ".././types"

export const getGetUserBusinessesResponseMock = (): UserBusinessesResponse => ({
	businesses: [
		{
			internalID: "biz_123",
			name: "Медицинский центр №1",
			showLeadsScreen: true,
			acl: ["SCREEN_LEADS", "LEADS_EDIT", "LEADS_DATA_EXPORT"],
			address: {
				locality: "Москва",
				street: "Ленина",
				streetType: "улица",
				number: "10",
				address: "Москва, улица Ленина, 10",
			},
		},
		{
			internalID: "biz_456",
			name: "Клиника Здоровье",
			showLeadsScreen: false,
			acl: ["SCREEN_LEADS"],
			address: {
				locality: "Санкт-Петербург",
				street: "Невский",
				streetType: "проспект",
				number: "25",
				address: "Санкт-Петербург, Невский проспект, 25",
			},
		},
		{
			internalID: "biz_789",
			name: "Филиал Омск",
			showLeadsScreen: true,
			acl: ["SCREEN_LEADS"],
			address: {
				locality: "Омск",
				street: "Карла Маркса",
				streetType: "проспект",
				number: "5",
				address: "Омск, проспект Карла Маркса, 5",
			},
		},
	],
	acl: ["read", "write", "admin"],
})

export const getGetUserProfileResponseMock = (): UserProfileResponse => ({
	profile: {
		name: "Иван",
		surname: "Петров",
		middleName: "Сергеевич",
		email: "ivan.petrov@example.com",
	},
})

export const getGetUserBusinessesMockHandler = (
	overrideResponse?:
		| UserBusinessesResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<UserBusinessesResponse> | UserBusinessesResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/user/businesses",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetUserBusinessesResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetUserProfileMockHandler = (
	overrideResponse?:
		| UserProfileResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<UserProfileResponse> | UserProfileResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/user",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetUserProfileResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}
export const getUserMock = () => [
	getGetUserBusinessesMockHandler(),
	getGetUserProfileMockHandler(),
]
